/**
 * Every Gateway path this module calls.
 *
 * Collected here so a route change is one edit, and so a reader can see the
 * module's entire surface against the platform without grepping for string
 * literals in JSX.
 */
export const cancellationPolicyEndpoints = {
  list: '/v1/cancellation-policies',
  create: '/v1/cancellation-policies',
  options: '/v1/cancellation-policies/options',
  detail: (policyId: string) => `/v1/cancellation-policies/${policyId}`,
  update: (policyId: string) => `/v1/cancellation-policies/${policyId}`,
  delete: (policyId: string) => `/v1/cancellation-policies/${policyId}`,
} as const;
